import RenderTemplate from "@components/cmsTemplates/RenderTemplate";
import { getPageTypes } from "@config/cms";
import ServerTimeout from "@modules/ServerTimeout/ServerTimeout";

export const renderPage = (props, pageType = getPageTypes().regular) => {
  return props.isTimeout ? (
    <ServerTimeout />
  ) : (
    <RenderTemplate {...props} type={pageType} />
  );
};
